import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  Spell,
} from "@dndModels";

import CharacterSpellBookRowInput from "@dndComponents/character/inventory/book/CharacterSpellBookRowInput";

interface Props {
  character: Character;
  level: number;
  spells_of_level: Spell[];
  onChange: () => void;
}

/**
 * Making it so that Books can have data stored in them.  
 * Book Types: Spell, Creature, Item, Other.
 * Spell Books work kind of like a collection of Scrolls, but can only be used for learning, not casting, but don't get used up in the process.
 * Creature Books and Item Books are just used to record and read info about them.
 * Other is the standard one, and it just has a place for the owner to record whatever they want.
 */
export default function CharacterSpellBookSpellsOfLevel({
  character,
  level,
  spells_of_level,
  onChange,
}: Props) {
  const [expanded_id, setExpandedId] = useState("");
  const [expanded, setExpanded] = useState(true);

  return (
    <Grid
      size={{
        xs: 12
      }}>
      <Grid container spacing={0} direction="row">
        <Grid
          className='header gray clickable'
          onClick={() => {
            setExpanded(!expanded);
          }}
          size={{
            xs: 12
          }}>
          { level === 0 ? "Cantrip" : `Level ${level}` }
        </Grid>
        { expanded && spells_of_level.map(spell => {
          return (
            <CharacterSpellBookRowInput key={spell._id}
              character={character}
              spell={spell}
              expanded={expanded_id === spell._id}
              onChange={onChange}
              onExpand={() => {
                setExpandedId(expanded_id === spell._id ? "" : spell._id);
              }}
            />
          );
        })}
      </Grid>
    </Grid>
  );
}
